import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  exportExcel,
  uploadPositioningdevicefittingsFile,
  bindPositioningdeviceInfo,
  unBindPositioningdeviceInfo,
  getMyPositioningdeviceinfoUnBindPositioningdeviceInfo,
  changeInstaller,
  batchChangeInstaller,
  changeGroup,
  batchChangeGroup,
  getMyPositioningdevicefitting,
  modifyFactoryGuaranteePeriod,
  batchModifyFactoryGuaranteePeriod,
  modifyClientGuaranteePeriod,
  batchModifyClientGuaranteePeriod
} from '@/api/positioningdevicefittingserv'

export default {
  state: {
    state_PositioningDeviceFitting_AddObjResult: null,
    state_PositioningDeviceFitting_GetAllResult: null,
    state_PositioningDeviceFitting_SearchByNameResult: null,
    state_PositioningDeviceFitting_GetPageResult: null,
    state_PositioningDeviceFitting_GetDetailResult: null,
    state_PositioningDeviceFitting_ModifyObjResult: null,
    state_PositioningDeviceFitting_DeleteObjResult: null,
    state_PositioningDeviceFitting_ExportExcelResult: null,
    state_PositioningDeviceFitting_UploadPositioningdevicefittingsFileResult: null,
    state_PositioningDeviceFitting_BindPositioningdeviceInfoResult: null,
    state_PositioningDeviceFitting_UnBindPositioningdeviceInfoResult: null,
    state_PositioningDeviceFitting_GetMyPositioningdeviceinfoUnBindPositioningdeviceInfoResult: null,
    state_PositioningDeviceFitting_ChangeInstallerResult: null,
    state_PositioningDeviceFitting_BatchChangeInstallerResult: null,
    state_PositioningDeviceFitting_ChangeGroupResult: null,
    state_PositioningDeviceFitting_BatchChangeGroupResult: null,
    state_PositioningDeviceFitting_GetMyPositioningdevicefittingResult: null,
    state_PositioningDeviceFitting_ModifyFactoryGuaranteePeriodResult: null,
    state_PositioningDeviceFitting_BatchModifyFactoryGuaranteePeriodResult: null,
    state_PositioningDeviceFitting_ModifyClientGuaranteePeriodResult: null,
    state_PositioningDeviceFitting_BatchModifyClientGuaranteePeriodResult: null
  },
  mutations: {
    SET_POSITIONINGDEVICEFITTING_ADDOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_AddObjResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_GETALL_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_GetAllResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_SearchByNameResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_GETPAGE_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_GetPageResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_GETDETAIL_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_GetDetailResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_ModifyObjResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_DELETEOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_DeleteObjResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_ExportExcelResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_UPLOADPOSITIONINGDEVICEFITTINGSFILE_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_UploadPositioningdevicefittingsFileResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_BINDPOSITIONINGDEVICEINFO_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_BindPositioningdeviceInfoResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_UNBINDPOSITIONINGDEVICEINFO_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_UnBindPositioningdeviceInfoResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_GETMYPOSITIONINGDEVICEINFOUNBINDPOSITIONINGDEVICEINFO_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_GetMyPositioningdeviceinfoUnBindPositioningdeviceInfoResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_CHANGEINSTALLER_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_ChangeInstallerResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_BATCHCHANGEINSTALLER_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_BatchChangeInstallerResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_CHANGEGROUP_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_ChangeGroupResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_BATCHCHANGEGROUP_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_BatchChangeGroupResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_GETMYPOSITIONINGDEVICEFITTING_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_GetMyPositioningdevicefittingResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_MODIFYFACTORYGUARANTEEPERIOD_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_ModifyFactoryGuaranteePeriodResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_BATCHMODIFYFACTORYGUARANTEEPERIOD_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_BatchModifyFactoryGuaranteePeriodResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_MODIFYCLIENTGUARANTEEPERIOD_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_ModifyClientGuaranteePeriodResult = rst
    },
    SET_POSITIONINGDEVICEFITTING_BATCHMODIFYCLIENTGUARANTEEPERIOD_RESULT: (state, rst) => {
      state.state_PositioningDeviceFitting_BatchModifyClientGuaranteePeriodResult = rst
    }
  },
  actions: {
    PositioningDeviceFittingServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_ExportExcel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_EXPORTEXCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_EXPORTEXCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_UploadPositioningdevicefittingsFile ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        uploadPositioningdevicefittingsFile(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_UPLOADPOSITIONINGDEVICEFITTINGSFILE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_UPLOADPOSITIONINGDEVICEFITTINGSFILE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_BindPositioningdeviceInfo ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        bindPositioningdeviceInfo(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_BINDPOSITIONINGDEVICEINFO_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_BINDPOSITIONINGDEVICEINFO_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_UnBindPositioningdeviceInfo ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        unBindPositioningdeviceInfo(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_UNBINDPOSITIONINGDEVICEINFO_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_UNBINDPOSITIONINGDEVICEINFO_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_GetMyPositioningdeviceinfoUnBindPositioningdeviceInfo ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyPositioningdeviceinfoUnBindPositioningdeviceInfo(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_GETMYPOSITIONINGDEVICEINFOUNBINDPOSITIONINGDEVICEINFO_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_GETMYPOSITIONINGDEVICEINFOUNBINDPOSITIONINGDEVICEINFO_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_ChangeInstaller ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changeInstaller(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_CHANGEINSTALLER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_CHANGEINSTALLER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_BatchChangeInstaller ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchChangeInstaller(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_BATCHCHANGEINSTALLER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_BATCHCHANGEINSTALLER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_ChangeGroup ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changeGroup(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_CHANGEGROUP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_CHANGEGROUP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_BatchChangeGroup ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchChangeGroup(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_BATCHCHANGEGROUP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_BATCHCHANGEGROUP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_GetMyPositioningdevicefitting ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyPositioningdevicefitting(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_GETMYPOSITIONINGDEVICEFITTING_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_GETMYPOSITIONINGDEVICEFITTING_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_ModifyFactoryGuaranteePeriod ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyFactoryGuaranteePeriod(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_MODIFYFACTORYGUARANTEEPERIOD_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_MODIFYFACTORYGUARANTEEPERIOD_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_BatchModifyFactoryGuaranteePeriod ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchModifyFactoryGuaranteePeriod(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_BATCHMODIFYFACTORYGUARANTEEPERIOD_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_BATCHMODIFYFACTORYGUARANTEEPERIOD_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_ModifyClientGuaranteePeriod ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyClientGuaranteePeriod(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_MODIFYCLIENTGUARANTEEPERIOD_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_MODIFYCLIENTGUARANTEEPERIOD_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingServ_BatchModifyClientGuaranteePeriod ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchModifyClientGuaranteePeriod(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTING_BATCHMODIFYCLIENTGUARANTEEPERIOD_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTING_BATCHMODIFYCLIENTGUARANTEEPERIOD_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_PositioningDeviceFitting_AddObjResult: state => {
      return state.state_PositioningDeviceFitting_AddObjResult
    },
    get_PositioningDeviceFitting_GetAllResult: state => {
      return state.state_PositioningDeviceFitting_GetAllResult
    },
    get_PositioningDeviceFitting_SearchByNameResult: state => {
      return state.state_PositioningDeviceFitting_SearchByNameResult
    },
    get_PositioningDeviceFitting_GetPageResult: state => {
      return state.state_PositioningDeviceFitting_GetPageResult
    },
    get_PositioningDeviceFitting_GetDetailResult: state => {
      return state.state_PositioningDeviceFitting_GetDetailResult
    },
    get_PositioningDeviceFitting_ModifyObjResult: state => {
      return state.state_PositioningDeviceFitting_ModifyObjResult
    },
    get_PositioningDeviceFitting_DeleteObjResult: state => {
      return state.state_PositioningDeviceFitting_DeleteObjResult
    },
    get_PositioningDeviceFitting_ExportExcelResult: state => {
      return state.state_PositioningDeviceFitting_ExportExcelResult
    },
    get_PositioningDeviceFitting_UploadPositioningdevicefittingsFileResult: state => {
      return state.state_PositioningDeviceFitting_UploadPositioningdevicefittingsFileResult
    },
    get_PositioningDeviceFitting_BindPositioningdeviceInfoResult: state => {
      return state.state_PositioningDeviceFitting_BindPositioningdeviceInfoResult
    },
    get_PositioningDeviceFitting_UnBindPositioningdeviceInfoResult: state => {
      return state.state_PositioningDeviceFitting_UnBindPositioningdeviceInfoResult
    },
    get_PositioningDeviceFitting_GetMyPositioningdeviceinfoUnBindPositioningdeviceInfoResult: state => {
      return state.state_PositioningDeviceFitting_GetMyPositioningdeviceinfoUnBindPositioningdeviceInfoResult
    },
    get_PositioningDeviceFitting_ChangeInstallerResult: state => {
      return state.state_PositioningDeviceFitting_ChangeInstallerResult
    },
    get_PositioningDeviceFitting_BatchChangeInstallerResult: state => {
      return state.state_PositioningDeviceFitting_BatchChangeInstallerResult
    },
    get_PositioningDeviceFitting_ChangeGroupResult: state => {
      return state.state_PositioningDeviceFitting_ChangeGroupResult
    },
    get_PositioningDeviceFitting_BatchChangeGroupResult: state => {
      return state.state_PositioningDeviceFitting_BatchChangeGroupResult
    },
    get_PositioningDeviceFitting_GetMyPositioningdevicefittingResult: state => {
      return state.state_PositioningDeviceFitting_GetMyPositioningdevicefittingResult
    },
    get_PositioningDeviceFitting_ModifyFactoryGuaranteePeriodResult: state => {
      return state.state_PositioningDeviceFitting_ModifyFactoryGuaranteePeriodResult
    },
    get_PositioningDeviceFitting_BatchModifyFactoryGuaranteePeriodResult: state => {
      return state.state_PositioningDeviceFitting_BatchModifyFactoryGuaranteePeriodResult
    },
    get_PositioningDeviceFitting_ModifyClientGuaranteePeriodResult: state => {
      return state.state_PositioningDeviceFitting_ModifyClientGuaranteePeriodResult
    },
    get_PositioningDeviceFitting_BatchModifyClientGuaranteePeriodResult: state => {
      return state.state_PositioningDeviceFitting_BatchModifyClientGuaranteePeriodResult
    }
  }
}
